import { Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatWidgetService {

  constructor(private readonly httpService: AmplifyHttpClient) {}

  getMessages() {
    return this.httpService.get(`api/message`, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  sendUserMessage(data: any) {
    return this.httpService.post(`api/message/user`, data, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  sendMessage(data: any) {
    return this.httpService.post(`api/message`, data, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  sendQuestionMessage(data: any) {
    return this.httpService.post(`api/message/question`, data, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getTipsMessage(data: any) {
    const params = {
      "vault_user_form_id": data.vault_user_form_id,
      "message": data.message,
      "template_type": data.template_type
    }
    return this.httpService.post(`api/message/template-question`, params, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getSummaryMessage(data: any) {
    const params = {
      "vault_user_form_id": data.vault_user_form_id,
      "message": data.message,
      "template_type": data.template_type
    }
    return this.httpService.post(`api/message/template-summary`, params, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  createCache(body: any = {}) {
    return this.httpService.post(`api/data-extraction/vector-management/create-cache`, body, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  createSession(data: any) {
    return this.httpService.post(`api/message/create-session`, data, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  updateMessage(data: any) {
    return this.httpService.patch(`api/message/update-message`, data, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  deleteMessage(key: string) {
    return this.httpService.delete(`api/message/${decodeURIComponent(key)}`, {}, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getUserSessions() {
    return this.httpService.get(`api/message/user-sessions`, {}, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getMessagesBySessionId(sessionId: string) {
    return this.httpService.get(`api/message/${sessionId}`, {}, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getFormDataForChat(data: any) {
    return this.httpService.post(`api/data-extraction/vector-management/form-data-for-chat`, data, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }
}
